import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/catalyst/button';
import { ErrorPageLayout } from '@/components/errors/ErrorPageLayout';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate('/', { replace: true });
  };

  return (
    <ErrorPageLayout
      code="404"
      label="PAGINA NON TROVATA"
      title="Pagina non trovata"
      description="La pagina che stai cercando non esiste, è stata spostata oppure non è più disponibile."
      actions={
        <>
          <Button
            type="button"
            color="dark/white"
            onClick={() => navigate('/', { replace: true })}
            className="focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-700 dark:focus-visible:outline-zinc-200"
          >
            Torna alla dashboard
          </Button>
          <Button
            type="button"
            plain
            onClick={handleBack}
            className="!px-0 !text-sm !font-medium !text-zinc-600 hover:!text-zinc-900 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-700 dark:!text-zinc-400 dark:hover:!text-zinc-200 dark:focus-visible:outline-zinc-200"
          >
            Torna indietro <span aria-hidden="true">→</span>
          </Button>
        </>
      }
    />
  );
};

export default NotFound;
